<div class="checkbox-wrapper">
    <div id="tour-year-truncation">
        <input class="checks__input" id="truncationChk" type="checkbox" (change)="onTruncationToggleChange($event)"
            [checked]="isTruncationChecked" />
        <label class="checks__label" for="truncationChk"></label>
        <span class="checkbox-text">Apply a {{ this.years }} year truncation point?</span>

    </div>
    <div id="tour-covid-truncation">
        <input class="checks__input" id="covidChk" type="checkbox" (change)="onCovidToggleChange($event)"
            [checked]="isAdjustedForCovidChecked" />
        <label class="checks__label" for="covidChk"></label>
        <span class="checkbox-text">Adjust for Covid?</span>

    </div>
</div>